/** @format */

import React, { FC } from "react";
import styled from "styled-components";
import { TruncaterProps } from "./truncater.types";

const WrapperClamp = styled.div<TruncaterProps>`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${({ lines }) => lines || 4};
  line-clamp: ${({ lines }) => lines || 4};
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  max-width: ${({ maxWidth }) => maxWidth || "100%"};
  text-align: left;
`;
const WrapperOneLine = styled.div<TruncaterProps>`
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || "290px"};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
`;

const Truncater: FC<TruncaterProps> = ({ children, lines, maxWidth }) => {
  const Wrapper = lines === 1 ? WrapperOneLine : WrapperClamp;

  return (
    <Wrapper
      lines={lines}
      maxWidth={maxWidth}
    >
      {children}
    </Wrapper>
  );
};

export default Truncater;
